"use client";

import "./static/cms-br.css";

export default function LegacyStylesBR() {
  return null;
}
